import React from "react"
import Header from "../../components/shared/Header/Header"
import { StringParam, useQueryParams } from "use-query-params"
import { isMobile } from "react-device-detect"
import style from "../../components/shared/PageStyle.module.css"
import { usePageStyleWithPlayer } from "../../util/usePageStyleWithPlayer"
import SearchResults from "./SearchResults"

interface User {
  id: number
  email: string
  first_name?: string
  last_name?: string
}

interface SearchResultsPageProps {
  user: User | null
  query?: string | null
}

export const SearchResultsPage: React.FC<SearchResultsPageProps> = ({
  user,
  query: propQuery = null,
}) => {
  const [params] = useQueryParams({
    q: StringParam,
  })
  const query = propQuery || params["q"]
  const pageStyle = usePageStyleWithPlayer()

  return (
    <div className={style.rootElStyle} style={pageStyle}>
      <Header user={user} query={query} />
      <div className="grid grid-cols-12 w-full pb-2 mt-4 px-3 lg:px-4">
        <div className="col-span-12">
          <div className="mt-4" />

          <SearchResults query={query || ""} cols={isMobile ? 1 : 4} />
        </div>
      </div>
    </div>
  )
}

export default SearchResultsPage
